
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';



@Injectable({
    providedIn: 'root'
  })
export class CauseService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
    }
    

    getCurrentCause() {
        return this.http.get(`/api/v1/causes/current_cause`);
    }
    getAllCause() {
        return this.http.get(`/api/v1/causes`);
    }
    


    
}
